import React from 'react';
import PropTypes from 'prop-types';

import {
  StyledDefaultButton,
  StyledPrimaryButton,
  StyledSecondaryButton,
  StyledTransparentButton,
} from './styled';

const Button = ({ tag: Tag, color, type, children, onClick, ...restProps }) => {
  const StyledColorButton = {
    primary: StyledPrimaryButton,
    secondary: StyledSecondaryButton,
    transparent: StyledTransparentButton,
    [null]: StyledDefaultButton,
  };
  const StyledButton = StyledColorButton[color];
  return (
    <StyledButton {...restProps} as={Tag} onClick={onClick} type={type}>
      {children}
    </StyledButton>
  );
};

Button.propTypes = {
  type: PropTypes.oneOf(['icon', 'block']),
  color: PropTypes.oneOf(['primary', 'secondary', 'transparent']),
  tag: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  type: null,
  color: null,
  tag: 'button',
  children: null,
  onClick: () => {},
};

Button.displayName = 'Button';

export default Button;
